export default function () {
    const chartsArr = Array.from(document.querySelectorAll('.at-chart'));

    chartsArr.forEach(chart => {
        const pillarArr = Array.from(chart.querySelectorAll('.pillar-wrapper'));

        pillarArr.forEach(pillar => {
            const percent = pillar.querySelector('.percentage');
            percent.style.width = `${percent.dataset.percentage}%`;
        })
    })
}